var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slick-carousel"},[_c('vueper-slides',{attrs:{"autoplay":_vm.autoplayCard,"pause-on-hover":true,"touchable":true,"fade":"","fixed-height":_vm.fixedHeight,"slide-ratio":1 / 2,"fractions":"","arrows":_vm.arrows}},_vm._l((_vm.images),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21215786","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/slickCarousel.vue
// module id = null
// module chunks = 